import type { SVGProps } from 'react';
import * as React from 'react';
import { forwardRef, Ref } from 'react';

const SvgGift = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 16 17"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeWidth={1.2}
      d="M9.667 7.833h3.666v3.333a4 4 0 0 1-4 4H6.667a4 4 0 0 1-4-4V7.833h3.666M11 7.833h1.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5h-9A1.5 1.5 0 0 0 2 6v.333a1.5 1.5 0 0 0 1.5 1.5H5M8 3.5c0-.92.746-1.667 1.667-1.667H10A1.333 1.333 0 0 1 10 4.5H8zM8 3.5c0-.92-.746-1.667-1.667-1.667H6A1.333 1.333 0 0 0 6 4.5h2z"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.2}
      d="M9.667 4.5v10.667H6.333V4.5z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgGift);
export default ForwardRef;
